import { render, staticRenderFns } from "./ConvoCommentStatementEdit.vue?vue&type=template&id=4d136320&"
import script from "./ConvoCommentStatementEdit.vue?vue&type=script&lang=js&"
export * from "./ConvoCommentStatementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports